import moment from 'moment-timezone'

export function isValidDate(date: string | null | undefined) {
  if (!date) return false
  if (date.length !== 10) return false
  return moment(date, 'DD/MM/YYYY', true).isValid()
}
